import { ToastContentProps } from 'react-toastify';

type ToastProps = ToastContentProps<{
  /**
   * Title or heading for a given context or section.
   * This property is optional and can be left undefined.
   * If defined, it typically holds a concise, descriptive string.
   */
  title?: string;

  /**
   * Textual content that can be optionally provided.
   * This variable can hold a string value or remain undefined if no content is specified.
   */
  content?: string;
}>;

/**
 * Toast notification with optional title and content.
 */
export function Toast({ data }: ToastProps) {
  return (
    <div className="flex flex-col w-full">
      {data.title && <h3 className="text-sm font-semibold">{data.title}</h3>}
      {data.content && <p className="text-sm">{data.content}</p>}
    </div>
  );
}
